import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';
import SBPopup from './SBPopup.vue';


@Component({
    components: {
        SBPopup,
    }
})
export default class SBLoading extends Mixins(SBComponentVue) {

}
